<global-search-form [formModel]="data" (formSubmit)="submit($event)"></global-search-form>

<div *ngIf="!collapsed" class="navbar-dropdown p-2">
  <div *ngIf="loading" class="d-flex align-items-center justify-content-center">
    <loading-spinner></loading-spinner>
  </div>

  <block-empty-msg *ngIf="isEmpty">Nothing found</block-empty-msg>

  <ng-container *ngFor="let result of results">
    <global-search-block-wrapper
      *ngIf="result.items?.length"
      [totalCount]="result.items?.length || 0"
      [itemsCount]="result.items?.length || 0"
      [caption]="result.title | label"
      class="block"
      [attr.data-id]="result.title | lowercase"
    >
      <ng-container [ngSwitch]="result.title">
        <ng-container *ngSwitchCase="'CLIENTS'">
          <my-clients-block
            [clients]="$any(result.items)"
            (rowClick)="clearSearch()"
          ></my-clients-block>
        </ng-container>

        <ng-container *ngSwitchCase="'MY_CLIENTS'">
          <my-clients-block
            [clients]="$any(result.items)"
            (rowClick)="clearSearch()"
          ></my-clients-block>
        </ng-container>

        <ng-container *ngSwitchCase="'OTHER_CLIENTS'">
          <my-clients-block [clients]="$any(result.items)" (rowClick)="clearSearch()" />
        </ng-container>

        <ng-container *ngSwitchCase="'MY_LEADS'">
          <my-leads-block [leads]="$any(result.items)" (rowClick)="clearSearch()"></my-leads-block>
        </ng-container>

        <ng-container *ngSwitchCase="'OTHER_LEADS'">
          <my-leads-block
            [leads]="$any(result.items)"
            (rowClick)="clearSearch()"
            (assignLead)="assignLead($event)"
          />
        </ng-container>

        <ng-container *ngSwitchCase="'ORDERS'">
          <result-orders-block
            (rowClick)="clearSearch()"
            [orders]="$any(result.items)"
          ></result-orders-block>
        </ng-container>

        <ng-container *ngSwitchCase="'BOOKINGS'">
          <result-bookings-block
            (rowClick)="clearSearch()"
            [bookings]="$any(result.items)"
          ></result-bookings-block>
        </ng-container>
      </ng-container>
    </global-search-block-wrapper>
  </ng-container>
</div>

<ng-template #assignLeadForm>
  <modal-v2 header="Confirm Lead Assignment">
    <assign-lead-form (hideModal)="hideModal()" (formSubmit)="submitAssignLead($event)" />
  </modal-v2>
</ng-template>
